import ToolbarButton from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarButton';

const Italic = () => (
  <ToolbarButton
    className="ql-italic"
    text={__('Italic')}
    iconName="italic"
    dataTestId="toolbar-italic"
  />
);

export default Italic;
